import React from 'react'
import {resolveWhiteLabelThemeId} from "../config/whiteLabelThemes";
import EnsingFooter from "./WhiteLabel/EnsingFooter";
import NewWayFooter from "./WhiteLabel/NewWayFooter";
import PrivateShareFooter from "./WhiteLabel/PrivateShareFooter";

const Footer = () => {
    const themeId = resolveWhiteLabelThemeId()

    if (themeId === "kav2go") {
        return null
    }

    if (themeId === "ensing") {
        return <EnsingFooter/>
    }

    if (themeId === "privateshare") {
        return <PrivateShareFooter/>
    }

    return <NewWayFooter/>
}

export default Footer